import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, int32_type, option_type, bool_type, union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ContractTypeListing", "General", "Mortgage", "ActivationState", "Subproducts", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Containers.ContractType.Model.Page", [], Page, () => [[], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], []]);
}

export class CreateContractTypeDTO extends Record {
    constructor(Active, ContractTypePriceId, Display, NetworkContractNr, PriceListCode, ProductNr) {
        super();
        this.Active = Active;
        this.ContractTypePriceId = ContractTypePriceId;
        this.Display = Display;
        this.NetworkContractNr = NetworkContractNr;
        this.PriceListCode = PriceListCode;
        this.ProductNr = ProductNr;
    }
}

export function CreateContractTypeDTO$reflection() {
    return record_type("Containers.ContractType.Model.CreateContractTypeDTO", [], CreateContractTypeDTO, () => [["Active", option_type(bool_type)], ["ContractTypePriceId", option_type(int32_type)], ["Display", string_type], ["NetworkContractNr", option_type(int32_type)], ["PriceListCode", option_type(string_type)], ["ProductNr", option_type(int32_type)]]);
}

